import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { ContractListItemSource } from '../models/contractListItemSource';
import { ContractSource } from '../models/contractSource';
import { observableToBeFn } from 'rxjs/testing/TestScheduler';
import { PropertyListItem } from '../models/propertyListItem';
import { Property } from '../models/property';

@Injectable()
export class PropertyService {

    constructor(private http: HttpClient, private global: Env) { }

    getAll( page:number = 0 , dni:string = "" , ruc:string = "" , size:number = 10 ):Observable<PropertyListItem[]>{
      let filtro = "";

      if ( dni > "" ){
        filtro = "&dni="+dni;
      }
      if ( ruc > "" ) {
        filtro = "&ruc="+ruc;
      }
      
      const url = this.global.property+'/list?page='+page+filtro+'&size='+size;
      console.log(url);
      return this.http.get(url).map((res: any[]) => {
        return res;
      });
    }

    get(id):Observable<Property> {
      const url = this.global.property+'/'+id;
      return this.http.get(url).map((res: Property) => {
        return res;
      });
      
    }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/property.service.ts